import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { z } from 'zod';

export const verifyPharmacyEmailRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/verify_pharmacy_email',
  validateSearch: z.object({
    token: z.preprocess((v) => (v === undefined ? undefined : `${v}`), z.string()),
  }),
}).lazy(() =>
  import('pages/shared/VerifyPharmacyEmailPage/VerifyPharmacyEmailPage').then((d) => d.Route)
);
